// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"G_cn","arrowLeft":"G_cY","arrowRight":"G_cZ"};